module.exports = __webpack_public_path__ + "img/empty.f30f875d.png";